/**
 * Canonical product name so duplicate SKUs of the same item share pack promos.
 * "TRENCITO CHOCOLATE BARRA 14 GR NESTLE" and "TRENCITO 14 GR NESTLE" → "TRENCITO 14 GR"
 */
export function canonProductName(nombre) {
    let s = String(nombre || '')
        .toUpperCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    s = s.replace(/(\d+)\s*(GR|G|ML|CC|KG|L|UN|U)\b/g, '$1 $2');
    s = s.replace(/[^A-Z0-9]+/g, ' ');
    s = s.replace(/\b(CHOCOLATE|CHOCO|BARRA|NESTLE|UNIDAD|UNIDADES)\b/g, ' ');
    return s.replace(/\s+/g, ' ').trim();
}
